import { TEXT_COLORS } from '@constants/colors.ts';
import { BODY_SM_SM_STYLES, STYLED_COMPONENTS_TEXT } from '@constants/text.ts';
import type { StyledCardProps } from '@routes/sidebar/notifications/ui/notification-card/styled.tsx';
import styled from 'styled-components';

export const CardInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-2xs, 4px);
    flex: 1 0 0;
`;

export const CardInfoTopBarPills = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-xs, 8px);
`;

export const CardInfoTopic = styled.div`
    display: flex;
    padding: 0px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
`;

export const CardInfoTopBar = styled.div`
    display: flex;
    padding: var(--spacing-sm, 16px) var(--spacing-sm, 16px) var(--spacing-2xs, 4px) var(--spacing-sm, 16px);
    align-items: center;
    gap: var(--spacing-xs, 8px);
    align-self: stretch;
`;

export const CardInfoTopicWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px 0px;
    align-items: flex-start;
    gap: 2px;
    align-self: stretch;
`;

export const CardInfoTopicText = styled(STYLED_COMPONENTS_TEXT['Heading/Heading-S'])`
    flex: 1 0 0;
    color: ${TEXT_COLORS.filled};
`;

export const CardInfoTopicCalendarRow = styled.div<Pick<StyledCardProps, '$isExpanded'>>`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    align-self: stretch;
    padding-bottom: ${({ $isExpanded }) => ($isExpanded ? '0px' : '6px')};
    transition: padding-bottom 0.5s ease;
`;

export const CardInfoTopicCalendar = styled.div<StyledCardProps>`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const CardInfoTopicCalendarIco = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
`;

export const CardInfoTopicCalendarText = styled(STYLED_COMPONENTS_TEXT['body/sm/sm'])`
    color: ${TEXT_COLORS.disabledGray};
`;

export const SystemSourceDescription = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_STYLES};
`;

export const CardInfoMetaText = styled.div`
    color: var(--colors-text-on-disabled, #70768d);
    ${BODY_SM_SM_STYLES};
`;

export const CardInfoAssesseeName = styled.div`
    display: flex;
    align-items: center;
    color: var(--colors-text-on-disabled, #70768d);
    ${BODY_SM_SM_STYLES};
`;
